import Advise from "./components/advise"
import Training from "./components/training"
import './styles.scss';

const TrainingAdvise = () => {
    return (
        <div className="traning-advise-block container">
            <Training/>
            <Advise />
        </div>
    )
}

export default TrainingAdvise